import { useEffect, useState } from "react"

// The timezone all the discount/countdown dates are set in
const TIMEZONE = "America/Los_Angeles"

// Difference between the date shown as TIMEZONE time and the visitor's local time
const getTimezoneDiff = date =>
  new Date(
    date.toLocaleString("en-US", {
      timeZone: TIMEZONE,
    }),
  ).getTime() - date.getTime()

// Change the target date timezone and calculate the difference with the current timezone
// The difference is calculated twice: the second time at the converted date, so the result is correct when
// a daylight saving time change happens between the visitor's time and the TIMEZONE time
// (e.g. visitors in Hawaii got an extra hour for a 10/31 23:59:59 end date, because DST ends on 11/1)
export const changeTimezone = date => {
  const firstPass = new Date(date.getTime() - getTimezoneDiff(date))
  return new Date(date.getTime() - getTimezoneDiff(firstPass))
}

export const useCountdown = targetDate => {
  // Set the target date in PST timezone
  const countDownDate = changeTimezone(new Date(targetDate))

  // Set the state of the countdown, the target time - the current time
  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime())

  // Activate the countdown
  useEffect(() => {
    let interval = null

    if (countDownDate - new Date().getTime() < 0) {
      clearInterval(interval)
      return
    }

    interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])

  return getReturnValues(countDown)
}

// Calculate days, hours, minutes, seconds left
const getReturnValues = countDown => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

  if (days + hours + minutes + seconds <= 0) {
    return [0, 0, 0, 0]
  } else {
    return [days, hours, minutes, seconds]
  }
}

// Check if the current day is in the [start date, end date] range
export const compareDates = (today, startDate, endDate) => {
  let currentTime = today.getTime()
  let startTime = changeTimezone(new Date(startDate)).getTime()
  let endTime = changeTimezone(new Date(endDate)).getTime()

  return currentTime >= startTime && currentTime <= endTime
}
